<template>
  <CRow class="justify-content-center">
  <CCol>
    <CCard>
      <CForm @submit.prevent="save">
        <CCardHeader class="pb-4">
          <strong>Biên tập thông tin license</strong>
          <div class="card-header-actions">
            <CButton type="submit" color="info" shape="pill" class="mr-2"
            >
              <CIcon name="cil-save"/>
              Lưu
            </CButton>

            <CButton v-if="productID" type="button" color="secondary" shape="pill" class="mr-2"
                     @click="refreshPage"
            >
              <CIcon name="cil-sync"/>
              Tải lại
            </CButton>

            <CButton v-if="getAllowDeleteButton" type="button" color="danger" shape="pill" class="mr-2"
                     @click="doDelete"
            >
              <CIcon name="cil-trash"/>
              Xóa
            </CButton>

            <CButton type="button" color="secondary" shape="pill" class="mr-2"
                     @click="goBack"
            >
              <CIcon name="cil-chevron-left"/>
              Quay lại
            </CButton>
          </div>
        </CCardHeader>
      <CCardBody>
        <CInput
          label="Product:"
          type="text"
          v-model="license.product"
          placeholder="Enter Product name"
          required
          horizontal
          :addLabelClasses="'text-right'"
        >
        </CInput>
        <CInput
          label="License ID:"
          type="text"
          v-model="license.uuid"
          placeholder="Enter Seri number of device"
          required
          horizontal
          :addLabelClasses="'text-right'"
        />
        <CInput
          label="License uid:"
          type="text"
          placeholder="Enter License uuid get from device"
          v-model="license.lic_uid"
          required
          horizontal
          :addLabelClasses="'text-right'"
        />
        <CTextarea
          label="License Key:"
          type="text"
          v-model="license.lic_key"
          placeholder="License key is auto generated by server"
          horizontal
          rows="4"
          :addLabelClasses="'text-right'"
        />
        <CSelect
          label="Status:"
          :value.sync="license.lic_status"
          :options="['Inactive', 'Active', 'Expired']"
          horizontal
          :addLabelClasses="'text-right'"
          >
        </CSelect>
        <CInput
          label="Issued date:"
          type="date"
          v-model="license.lic_issue"
          horizontal
          :addLabelClasses="'text-right'"
        />
        <CInput
          label="Expired date:"
          type="date"
          v-model="license.lic_expired"
          required
          horizontal
          :addLabelClasses="'text-right'"
        />
        <CTextarea
          label="Features:"
          type="text"
          v-model="license.lic_features"
          placeholder="Enter features"
          required
          horizontal
          rows="4"
          :addLabelClasses="'text-right'"
        />
      </CCardBody>
      </CForm>
    </CCard>
  </CCol>
  </CRow>
</template>

<script>

export default {
  data() {
    return {
      allowDelete: false,
      productID: '',
      license: {
        product: '',
        uuid: '',
        lic_key: '',
        lic_uid: '',
        lic_status: 'Inactive',
        lic_expired: '',
        lic_issue: '',
        lic_features: '',
      },
    };
  },
  created() {
    // console.log(this.$route)
    this.productID = this.$route.query.id
    if(this.productID) {
      this.refreshPage()
    }
  },
  computed: {
    getAllowDeleteButton() {
      return (this.allowDelete && this.productID)
    }
  },
  methods: {
    refreshPage() {
        this.$request.get(`/api/device/licenses/${this.productID}`).
        then(res=>{
          // console.log(res.data);
          if(res.data.status === 'success'){
            this.license=res.data.license
            if(this.license.lic_status === ''){
              this.license.lic_status= 'Inactive'
            }
          } else {
            // console.log('get license id error:', res.data.status)
          }
        })
    },
    save() {
      // console.log('Lưu license key: ', this.license)
      this.$swal.fire({
        title: "Lưu license key?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/device/licenses`, this.license).
          then(res => {
            if(res.data.status === 'success') {
              this.license = res.data.license;
              this.$swal.fire({
                icon: "success",
                title: this.productID ? "Cập nhật license key" : "Tạo license key mới",
                html: "Lưu license key thành công"
              });
              // this.$router.go(-1);
            } else {
              this.$swal.fire({
                icon: "error",
                title: this.productID ? "Cập nhật license key" : "Tạo license key mới",
                html: "Tạo license key " + this.license.uuid +
                  "<br>thất bại: " + res.data.status,
              });
            }
          })
        }
      });
    },
    doDelete() {
      // console.log("Delete product license id:", this.license.uuid);
      this.$swal.fire({
        title: "Xóa license key?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.delete(`/api/device/licenses/${this.license.uuid}`).
          then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Xóa license key",
                html: "Xóa license key: " + this.license.uuid + " thành công" ,
              });
              this.$router.go(-1);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xóa license key",
                html: "Xóa license key: " + this.license.uuid +
                  "<br> lỗi: " + res.data.status,
              });
            }
          })
        }
      });
    },
    goBack() {
      this.$router.go(-1)
    }
  },
};
</script>

<style>
/* Optional: Add some padding and styling */
.container {
  max-width: 600px;
}
</style>
